import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { IOrderInfo } from '../../interfaces/task-info';

export interface ISuppliers {
  id: number;
  name: string;
  rating: number;
  price: number;
  order: number;
}

@Component({
  templateUrl: './select-supplier.component.html',
  selector: 'select-supplier',
  styleUrls: ['./select-supplier.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SelectSupplierComponent implements OnInit {
  public IsBusy: boolean = false;
  public suppliers: Array<ISuppliers>;

  @Output() selectedSuppliersChange: EventEmitter<Array<string>>;
  private _selectedSuppliers: Array<string>;
  @Input('selectedSuppliers')
  public set selectedSuppliers(value: Array<string>) {
    this._selectedSuppliers = value;
    this.ChangeSelectSupplier(value);
    this.selectedSuppliersChange.emit(value);
  }
  public get selectedSuppliers(): Array<string> {
    return this._selectedSuppliers;
  }

  @Output() jobChange: EventEmitter<IOrderInfo>;
  private _job: IOrderInfo;
  @Input('job')
  public set job(value: IOrderInfo) {
    this._job = value;
    if (value) {
      var selectedSuppliers = [];
      for (var i = 0; i < value.selectedSuppliers.length; i++) {
        selectedSuppliers.push(value.selectedSuppliers[i].supplierId.toString());
      }

      this.selectedSuppliers = selectedSuppliers;
    }
    this.jobChange.emit(value);
  }
  public get job(): IOrderInfo {
    return this._job;
  }

  @Output() selectSupplierChange: EventEmitter<ISuppliers>;
  private _selectSupplier: ISuppliers = null;
  @Input('selectSupplier')
  public set selectSupplier(value: ISuppliers) {
    this._selectSupplier = value;
    this.selectSupplierChange.emit(value);
  }
  public get selectSupplier(): ISuppliers {
    return this._selectSupplier;
  }

  constructor() {
    this.jobChange = new EventEmitter<IOrderInfo>();
    this.selectSupplierChange = new EventEmitter<ISuppliers>();
    this.selectedSuppliersChange = new EventEmitter<Array<string>>();
  }

  ngOnInit() {
    this.selectedSuppliers = [];
    this.suppliers = [];
    this.IsBusy = true;
    setTimeout(() => {
      var selectedSuppliers = [];

      if (this.job) {
        for (var i = 0; i < this.job.selectedSuppliers.length; i++) {
          selectedSuppliers.push(this.job.selectedSuppliers[i].supplierId.toString());
        }
      }

      this.suppliers.push({ id: 1, name: 'Alex Kavanaugh', rating: 4, price: 150, order: 1 });
      this.suppliers.push({ id: 2, name: 'Supplier', rating: 2, price: 130, order: 2 });
      this.suppliers.push({ id: 3, name: 'Test', rating: 2, price: 125, order: 3 });
      this.suppliers.push({ id: 999, name: 'VME', rating: 0, price: 100, order: 1000 });
      this.suppliers.sort((a, b) => {
        return a.order - b.order;
      });

      this.selectedSuppliers = selectedSuppliers;

      this.IsBusy = false;
    }, 1500);
  }

  ChangeSelectSupplier(newSelectedSupplier: Array<string>) {
    if (!this.job || !this.suppliers) return;

    var existId = [];
    for (var i = this.job.selectedSuppliers.length - 1; i >= 0; i--) {
      if (newSelectedSupplier.indexOf(this.job.selectedSuppliers[i].id.toString()) < 0) {
        this.job.selectedSuppliers.splice(i, 1);
      } else {
        existId.push(this.job.selectedSuppliers[i].id);
      }
    }

    for (var i = 0; i < newSelectedSupplier.length; i++) {
      if (existId.indexOf(Number(newSelectedSupplier[i])) < 0) {
        var selectedSupplier = this.suppliers.find((val, index) => {
          return val.id == Number(newSelectedSupplier[i]);
        });
        if (selectedSupplier) {
          this.job.selectedSuppliers.push({
            id: 0,
            jobSentToSupplierStatus: 0,
            order: selectedSupplier.order,
            price: selectedSupplier.price,
            sentToSupplier: null,
            supplierResponded: null,
            supplierId: selectedSupplier.id,
          });
        }
      }
    }
  }

  SelectSupplier(supplier: ISuppliers) {
    this.selectSupplier = supplier;
  }

  MoveToTop() {
    if (!this.selectSupplier) return;

    var index = this.suppliers.indexOf(this.selectSupplier);
    if (index < 0) return;

    var supplier = this.selectSupplier;

    this.suppliers.splice(index, 1);

    this.suppliers.unshift(supplier);
  }

  MoveUp() {
    if (!this.selectSupplier) return;

    var index = this.suppliers.indexOf(this.selectSupplier);
    if (index < 0) return;

    var supplier = this.selectSupplier;

    this.suppliers.splice(index, 1);

    this.suppliers.splice(index - 1, 0, supplier);
  }

  MoveDown() {
    if (!this.selectSupplier) return;

    var index = this.suppliers.indexOf(this.selectSupplier);
    if (index < 0) return;

    var supplier = this.selectSupplier;

    this.suppliers.splice(index, 1);

    this.suppliers.splice(index + 1, 0, supplier);
  }

  MoveToBottom() {
    if (!this.selectSupplier) return;

    var index = this.suppliers.indexOf(this.selectSupplier);
    if (index < 0) return;

    var supplier = this.selectSupplier;

    this.suppliers.splice(index, 1);

    this.suppliers.push(supplier);
  }
}
